import FingerPrintProvider, { FingerPrintContext } from './fingerPrintProvider';
import { useContext } from 'react';
export const useFingerPrint = () => {
    return useContext(FingerPrintContext);
};
export default FingerPrintProvider;
